import { CSSProperties, FC, useMemo } from 'react'

import { Tag, theme } from 'antd'

import Color from 'color'

const RiderNumber: FC<{ style?: CSSProperties; number?: number | null; color?: string | null }> = ({
  style: defaultStyle,
  number,
  color = '#000',
}) => {
  const {
    token: { fontSizeLG, colorBgContainer },
  } = theme.useToken()

  const style: CSSProperties = useMemo(() => {
    const background = Color(color ?? colorBgContainer)
    const style: CSSProperties = {
      ...defaultStyle,
      background: background.hex(),
      color: background.isDark() ? '#fff' : '#000',
      fontWeight: 'bold',
      fontSize: fontSizeLG,
      fontFamily: 'Russo One',
      width: 40,
      textAlign: 'center',
    }
    return style
  }, [color, colorBgContainer, defaultStyle, fontSizeLG])

  return (
    <Tag bordered={false} style={style}>
      {!number ? '?' : number}
    </Tag>
  )
}

export { RiderNumber }
